import { useSelector } from 'react-redux'

import { makeSelectRole } from '@webapp/core/stores/global'
import { PermissionGroupNames } from '@webapp/platform/_unmigrated/models/PermissionGroups'

/**
 * Whether the current user is a Super User — role is Superuser or EKA
 * (Site Administrator). Mirrors Angular's `Permissions.isSuperuser`.
 */
export const useIsSuperuser = (): boolean => {
  const role = useSelector(makeSelectRole())

  return (
    role?.name === PermissionGroupNames.SUPERUSER ||
    role?.name === PermissionGroupNames.SITE_ADMINISTRATOR
  )
}
